<h2>Recruiting</h2>


<div>

  <nz-tabset>

    <nz-tab nzTitle="New Recruit ">

      <form [formGroup]="recruitForm">

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="first_name" nzRequired>First Name</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="first_name" type="text" id="name" placeholder="First Name" required />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="last_name" nzRequired>Last Name</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="last_name" type="text" id="name" placeholder="Last Name" required />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="phone" nzRequired>Phone</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="phone" type="tel" id="phone" placeholder="Phone Number"
              mask="(000) 000-0000" placeholder="(123) 123-1234" required />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="email" nzRequired>E-mail</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="email" type="email" id="email" placeholder="Email" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="providers" nzRequired>Providers</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-select style="width: 100%;" nzMode="multiple" nzAllowClear nzShowSearch
              nzPlaceHolder="Select providers" formControlName="providers">
              <nz-option *ngFor="let p of currentUser?.providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

      </form>

      <div style="display: flex; justify-content: center; gap: 10px;">
        <button [nzLoading]="loading" nz-button nzType="default" style="width: 200px;"
          (click)="resetForm()">Reset</button>
        <button [nzLoading]="loading" nz-button nzType="primary" style="width: 200px;" (click)="submitRecruit()"
          [disabled]="recruitForm.invalid">Submit</button>
      </div>

    </nz-tab>


    <nz-tab *ngIf="myRecruits" nzTitle="My Recruits">

      <div class="recruit-list-toolbar">
        <nz-input-group nzPrefixIcon="search" class="recruit-list-toolbar__search">
          <input
            nz-input
            [formControl]="recruitSearchControl"
            placeholder="Search recruits by name, phone, or email" />
        </nz-input-group>

        <nz-select
          class="recruit-list-toolbar__filter"
          [formControl]="statusFilterControl">
          <nz-option nzLabel="All statuses" nzValue="all"></nz-option>
          <nz-option nzLabel="Completed" nzValue="completed"></nz-option>
          <nz-option nzLabel="Pending" nzValue="pending"></nz-option>
        </nz-select>
      </div>

      <nz-table
        #myRecruitsTable
        [nzData]="filteredRecruits"
        nzBordered
        nzShowSizeChanger
        [nzLoading]="myRecruitsLoading"
        [nzNoResult]="recruitNoResult">
        <thead>
          <tr>
            <th>Rep</th>
            <th>Onboarding Status</th>
            <th>Sent Date</th>
            <th>Date of Birth</th>
            <th>Phone</th>
            <th>email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of myRecruitsTable.data">
            <td>{{ r.rep }}</td>
            <td>
              <nz-tag [nzColor]="recruitLooksDone(r) ? 'green' : 'yellow'">
                {{ recruitLooksDone(r) ? 'Completed' : 'Pending' }}
              </nz-tag>
            </td>
            <td>{{ r.created_at | date }}</td>
            <td>
              {{ displayDateOfBirth(r) }}
            </td>
            <td>{{ r.phone }}</td>
            <td>{{ r.email }}</td>
            <td>
              <button nz-button nz-popover nzPopoverContent="View Recruit" nzType="primary" nzShape="circle"
                (click)="getRecruitInfo(r)">
                <span nz-icon nzType="eye" nzTheme="outline"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #recruitNoResult>
        <nz-empty
          [nzNotFoundContent]="recruitSearchControl.value ? 'No recruits match your search.' : 'No recruits found yet.'">
        </nz-empty>
      </ng-template>

    </nz-tab>
  </nz-tabset>

</div>


<nz-modal [(nzVisible)]="recruitModal" [nzFooter]="null" [nzTitle]="selectedRecruit?.r?.rep"
  (nzOnCancel)="recruitModal = false;">
  <ng-container *nzModalContent>
    <div *ngIf="currentUser?.super_admin && selectedRecruit && selectedRecruit.recruitedBy" class="recruit-modal__meta">
      <span class="recruit-modal__meta-label">Recruited By</span>
      <span class="recruit-modal__meta-value">
        {{ selectedRecruit?.recruitedBy | titlecase }}
      </span>
    </div>

    <div class="recruit-modal__progress">
      <nz-progress [nzPercent]="selectedRecruit?.completion" [nzShowInfo]="false"></nz-progress>
      <div class="recruit-modal__progress-meta">
        <span class="recruit-modal__percent">{{ selectedRecruit?.completion }}%</span>
        <span class="recruit-modal__status"
          [class.recruit-modal__status--complete]="selectedRecruit?.completion === 100">
          {{ selectedRecruit?.completion === 100 ? 'Complete' : 'In Progress' }}
        </span>
      </div>
    </div>

    <nz-descriptions *ngIf="selectedRecruit?.profileSummary?.length" class="recruit-modal__summary" nzBordered
      nzSize="small" [nzColumn]="1">
      <nz-descriptions-item *ngFor="let item of selectedRecruit?.profileSummary" [nzTitle]="item.label">
        <ng-container *ngIf="item.value; else pendingValue">
          <span>{{ item.value }}</span>
        </ng-container>
        <ng-template #pendingValue>
          <nz-tag nzColor="gold">Pending</nz-tag>
        </ng-template>
      </nz-descriptions-item>
    </nz-descriptions>

    <section class="recruit-modal__section">
      <h3 class="recruit-modal__section-title">
        {{ selectedRecruit?.completion === 100 ? 'All Set' : 'Outstanding Items' }}
      </h3>

      <div *ngIf="selectedRecruit?.completion === 100" class="recruit-modal__success">
        <span>✅ Rep completed all necessary steps to complete onboarding!</span>
      </div>

      <nz-list *ngIf="selectedRecruit?.completion !== 100 && selectedRecruit?.outstandingItems?.length"
        nzItemLayout="horizontal" class="recruit-modal__list">
        <nz-list-item *ngFor="let item of selectedRecruit?.outstandingItems">
          <span nz-typography><mark>{{ item.label }}</mark></span>
          <span>{{ item.message }}</span>
        </nz-list-item>
      </nz-list>

      <div *ngIf="selectedRecruit?.completion !== 100 && !selectedRecruit?.outstandingItems?.length"
        class="recruit-modal__empty">
        <span>No outstanding items found.</span>
      </div>
    </section>

    <section class="recruit-modal__section" *ngIf="selectedRecruit?.completedDocs?.length">
      <h3 class="recruit-modal__section-title">Completed Documents</h3>
      <nz-list nzItemLayout="horizontal" class="recruit-modal__list">
        <nz-list-item *ngFor="let doc of selectedRecruit?.completedDocs">
          <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
          <span class="recruit-modal__list-item-text">{{ doc.name || 'Document' }}</span>
        </nz-list-item>
      </nz-list>
    </section>

    <section class="recruit-modal__section" *ngIf="selectedRecruit?.completedQuizzes?.length">
      <h3 class="recruit-modal__section-title">Completed Quizzes</h3>
      <nz-list nzItemLayout="horizontal" class="recruit-modal__list">
        <nz-list-item *ngFor="let q of selectedRecruit?.completedQuizzes">
          <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
          <span class="recruit-modal__list-item-text">{{ q.name || 'Quiz' }}</span>
        </nz-list-item>
      </nz-list>
    </section>
  </ng-container>
</nz-modal>
